import * as React from "react";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import EasyPay from "assets/images/easy-pay.jpg";
import BankAccount from "assets/images/bank-account.jpg";
import Coins from "assets/images/coins.jpg";
import Repeat from "assets/images/repeat.jpg";

const proofs = [
  {
    icon: EasyPay,
    bgColor: "#EFE6EC",
    title: "Простий старт без зайвих кроків",
    text: "Для оплати по IBAN не потрібно реєструвати ПРРО чи еквайринг.",
  },
  {
    icon: BankAccount,
    bgColor: "#E6EFEA",
    title: "Рахунок в будь-якому банку",
    text: "Використовуйте рахунок організації чи ФОП відкритий в будь-якому банку України.",
  },
  {
    icon: Coins,
    bgColor: "#EFECE6",
    title: "Автоматизоване виставлення оплат",
    text: "Інтегруйте сервіс через API для безперервної генерації платіжних посилань.",
  },
  {
    icon: Repeat,
    bgColor: "#E3E4EA",
    title: "Посилання або оплата по QR коду",
    text: "Створюйте посилання на оплату чи QR-код і приймайте оплату за реквізитами IBAN без ручного введення рахунку.﻿",
  },
];

const SocialProof: React.FC = () => {
  return (
    <Container sx={styles.socialBlock}>
      <Box sx={styles.topHeading}>
        <Typography variant="h2" sx={{ mb: 2.5 }}>
          Чому саме IBAN oplata?
        </Typography>
        <Typography variant="h5">
          Відчуйте поєднання зручності, безпеки та ефективності своїх операцій.
        </Typography>
      </Box>
      <Box sx={styles.proofsWrapper}>
        {proofs.map((proof, index) => (
          <Box
            key={index}
            sx={[styles.proof, { backgroundColor: proof.bgColor }]}
          >
            <img style={styles.image} src={proof.icon} />
            <Typography variant="h3" sx={{ mb: 1.5, fontWeight: 400 }}>
              {proof.title}
            </Typography>
            <Typography sx={{ fontWeight: 400 }}>{proof.text}</Typography>
          </Box>
        ))}
      </Box>
    </Container>
  );
};

const styles = {
  socialBlock: {
    textAlign: "center",
    paddingTop: { xs: "56px", sm: "120px" },
    paddingBottom: { xs: "56px", sm: "120px" },
  },
  image: {
    borderRadius: "100px",
    marginBottom: "20px",
  },
  topHeading: {
    textAlign: "center",
    marginBottom: "60px",
  },
  proofsWrapper: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  proof: {
    width: { xs: "100%", sm: "48%" },
    textAlign: "left",
    borderRadius: "8px",
    padding: "20px",
    margin: "10px",
  },
};

export default SocialProof;
